import { createFileRoute } from "@tanstack/react-router";
import OwnerBrandingPage from "@/pages/OwnerBrandingPage";

export const Route = createFileRoute("/_owner/owner/branding")({
  component: OwnerBrandingPage,
});
